import { useLocale, useTranslate } from 'app/[locale]/hooks/useTranslate';
import { SectionTitle } from '../SectionTitle';
import Image from 'next/image';
import { useAttentionTracker } from 'app/[locale]/hooks/useAttentionTracker';

export const AuditLogSection = (): JSX.Element => {
  const { t } = useTranslate();
  const locale = useLocale();
  const { ref } = useAttentionTracker({ sectionName: 'main_audit_log' });

  return (
    <section
      className="md:space-y-32 space-y-16 md:max-w-homepage px-4 pt-10 md:py-32 md:px-10 xl:px-0"
      ref={ref}
    >
      <SectionTitle
        title={t.home.MAIN_AUDIT_LOG_TITLE}
        description={t.home.MAIN_AUDIT_LOG_DESC}
        className="*:!bg-gradient-pastel"
      />
      <Image
        className="w-full select-none"
        src={`/callabo/homepage/main/audit_log_${locale}.png`}
        width={1320}
        height={297}
        alt="audit_log"
      />
    </section>
  );
};
